import script from "./CareerYouthProgramsRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerYouthProgramsRegistration.vue?vue&type=script&setup=true&lang=js"

import "./CareerYouthProgramsRegistration.vue?vue&type=style&index=0&id=7ef24e76&lang=scss"

const __exports__ = script;

export default __exports__